(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1873],{

/***/ 98552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-store-subscription/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-02-22",
      tag: "eBay",
      title: "Why You Need An eBay Store Subscription",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay is a popular online shopping site best known for its auctions and is widely available in many countries. It's a favorite for millions of users worldwide, and anyone can open an eBay account for free."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In this article, we'll discuss everything you need to know about setting up a store on eBay and familiarizing yourself with the different types of stores, fees, and benefits that comes with being an eBay seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay has exponentially grown from the beginning since 1995. It is popular that you've probably heard about it from others or seen it on media such as TV, in the movies, or on the news. This is because users can buy and sell almost anything here, and millions of transactions occur daily.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This means that aside from common goods, merchants can also list highly sought-after things such as collectibles, discontinued items, vintage items, uncommon goods, or anything of limited availability. As a result, eBay has become the go-to location for collectors looking for items that aren't available locally. The vast assortment of things, extensive search capabilities, notification systems, user-friendliness of the site, and ability to avoid fraudulent transactions thanks to their anti-fraud measures have all drawn collectors to eBay. Some collectors even make a profession by buying and selling collectibles on eBay for hours each day."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Setting Up Your Store"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "By subscribing to eBay Store, you gain access to more resources to manage and market your business. Not only does it lets you get cheaper fees and more free listings monthly, but you also get access to other helpful tools that can help manage and promote your business."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Before you dive into setting up your store, you have to have:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "An eBay seller account. Ensure that it is has a linked checking account for payouts to ensure that seamless transfer of funds."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "An idea of what eBay Store features you will need for your store "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For starters, you have to set up your store by deciding what subscription level you want: Starter, Basic, Premium, Anchor, or Enterprise. After you've chosen, you can move on to the following:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to Choose a Store Subscription."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Find and select the eBay Store type you'd like to subscribe to. After that, choose Select and review."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Then select the subscription term (choose between yearly or monthly) and then finally enter a name for your eBay Store."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Once done, you can click \"Submit order\" to purchase the eBay Store subscription, and then you're all set!"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Why subscribe to eBay stores"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One of the great things about subscribing to eBay stores is that you receive access to more tools to manage and advertise your business. You also enjoy cheaper fees and more free listings each month when you subscribe to eBay Store."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What are the different types of stores, and how to determine the best option for you?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "eBay has five (5) different types of stores for users to choose from, and to determine what eBay store subscription is best for you, here's a brief overview:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Starter:"
        }), " This is ideal for sellers who have only have a handful of products and need a storefront brand to promote their business.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What you'll get for $4.95/monthly:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "250/monthly free auction listings in select categories"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free action listings in select categories or fixed-price listings"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Basic - ideal for sellers that need 250 zero-fee listings, final value discount features, and a coupon for eBay branded shipping supplies."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What you'll get is $21.95/monthly (with annual subscription):"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "10,000/monthly fixed-price listings"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "250/monthly free auction listings in select categories"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Lower final value fees"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free subscription to Terapeak Sales Insights tool"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "$25 of eBay branded shipping supplies per quarter"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Premium:"
        }), " This store is ideal for sellers with an extensive product assortment."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What you'll get is $59.95/monthly (with annual subscription):"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "10,000/monthly fixed-price listings"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "500/monthly free auction listings in select categories"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Lower final value fees"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free subscription to Terapeak Sales Insights tool"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "$50 of eBay branded shipping supplies per quarter"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Anchor:"
        }), " This is ideal for high-volume sellers with an extensive product catalog that would benefit from dedicated customer support."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What you'll get is $299.95/monthly (with an annual subscription):"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "25,000/monthly fixed-price listings"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "1,000/monthly free auction listings in select categories"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Lower final value fees"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free subscription to Terapeak Sales Insights tool"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "$150 of eBay branded shipping supplies per quarter"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Dedicated customer support"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Enterprise:"
        }), " This store is ideal for high-volume sellers who have an extensive product catalog and would benefit from dedicated customer support with over 100,000 categories with free fixed price insertions."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What you'll get is $2,999.95/monthly (with annual subscription):"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "100,000/monthly fixed-price listings"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "2,500/monthly free auction listings in select categories"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Lower final value fees"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free subscription to Terapeak Sales Insights tool"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "$150 of eBay branded shipping supplies per quarter"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Dedicated customer support"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "eBay Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Insertion Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You can acquire up to 250 no-cost listings every month or more if you have an eBay Store. Learn more about how zero-insertion-fee listings work, as well as the terms and conditions that apply to them. After you've used your zero insertion fee allowance, insertion fees will be:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Non-refundable even when the item doesn't sell"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Charged per listing and per category. So, you'll have to pay an insertion fee for the second category if you list your item in two categories"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Charged for the original listing and each time you choose to relist your item"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Charged per listing if you create duplicate auction-style listings for identical items. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Charged only once per listing for listings with multiple items."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Final Value Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When your item sells, eBay will charge a single final value fee. With this, you don't have to worry about third-party payment processing fees. This charge is based on a percentage of the total selling amount + $0.30 for each order."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The total amount of the sale includes the item price, and handling costs, the shipping option selected by the customer, sales tax, and any other fees that may be relevant. If you provide 1-day or international delivery, as well as a cheaper or free option (such as domestic shipping), the total value of the sale is computed using the cheapest domestic option. If you only provide 1-day or international delivery and no other, a less expensive alternative such as local shipping, the total cost of the sale is computed based on the total value of the transaction."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "eBay Store Benefits"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Having an eBay store subscription gives you major benefits such as easily attracting more buyers with eBay's access to tools like \"Promotions Manager\" that lets you create promotions to attract new buyers and boost traffic to your store."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Another benefit of selling on eBay is that you can explore the market with their \"Terapeak Sourcing Insights.\" This tool uses real-time eBay marketplace data to help you identify the top-performing categories and make informed decisions about your sales strategy."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "And last is, with eBay, you can own your brand and keep your regular customers while attracting new buyers."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["To start you out on eBay, another effective way to boost your sales and optimize your operations is to utilize an innovative and customizable tool designed to act as your virtual assistant. This tool is called OneShop.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop acts as your own sales expert as it can list and relist across multiple online marketplaces such as Mercari, Poshmark, Depop, and many more platforms soon. This will let you have more time working on other important things for your business rather than spending hours doing listings across platforms manually. The good news for eBay sellers is that cross-listing to eBay will be coming soon on OneShop!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Try it for yourself, register for free, and enjoy a 7-day trial with assistance from our team."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-store-subscription.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Why You Need An eBay Store Subscription"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn the basics of the different types of stores, fees, and benefits that comes with being an eBay seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-store-subscription"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-store-subscription"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Why You Need An eBay Store Subscription"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn the basics of the different types of stores, fees, and benefits that comes with being an eBay seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 80911:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-store-subscription",
      function () {
        return __webpack_require__(98552);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(80911); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);